import React, { useState } from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { useSelector } from "react-redux";

import { useCart } from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const {
    cartCount,
  } = useCart();

  const {
    restaurantName,
  } = useSelector(
    (state) => state.theme
  );


  const [
    menuOpen,
    setMenuOpen,
  ] = useState(false);


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  /*
  =====================================================
  CLOSE MENU
  =====================================================
  */

  const closeMenu = () => {
    setMenuOpen(false);
  };


  /*
  =====================================================
  HOME
  =====================================================
  */

  const goHome = () => {

    closeMenu();

    if (
      location.pathname === homePath
    ) {

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;
    }

    navigate(homePath);

  };


  /*
  =====================================================
  CART
  =====================================================
  */

  const goCart = () => {

    closeMenu();

    navigate(
      `${homePath}/cart`
    );

  };


  /*
  =====================================================
  SECTION NAVIGATION
  =====================================================
  */

  const navigateToSection = (
    sectionId
  ) => {

    closeMenu();


    /*
    ---------------------------------------------
    Already on home page
    ---------------------------------------------
    */

    if (
      location.pathname === homePath
    ) {

      const section =
        document.getElementById(
          sectionId
        );


      if (section) {

        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;
    }


    /*
    ---------------------------------------------
    Coming from another screen
    ---------------------------------------------
    */

    navigate(
      `${homePath}#${sectionId}`
    );

  };


  /*
  =====================================================
  MENU BUTTON
  =====================================================
  */

  const toggleMenu = () => {

    setMenuOpen(
      (previous) =>
        !previous
    );

  };


  return (

    <header className="theme4-header">


      {/* =================================================
          TOP GOLD LINE
      ================================================= */}

      <div className="theme4-header-gold-line"></div>


      <div className="theme4-header-inner">


        {/* =================================================
            LOGO
        ================================================= */}

        <button
          type="button"
          className="theme4-logo"
          onClick={goHome}
          aria-label="Go to home"
        >

          <span className="theme4-logo-symbol">
            M
          </span>


          <span className="theme4-logo-divider">
          </span>


          <span className="theme4-logo-name">

            <strong>
              {restaurantName ||
                "MAISON NOIR"}
            </strong>

            <small>
              FINE DINING
            </small>

          </span>

        </button>


        {/* =================================================
            DESKTOP NAV
        ================================================= */}

        <nav
          className={
            `theme4-navigation ${
              menuOpen
                ? "theme4-navigation-open"
                : ""
            }`
          }
        >

          <button
            type="button"
            onClick={goHome}
          >
            HOME
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "story"
              )
            }
          >
            OUR STORY
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "menu"
              )
            }
          >
            MENU
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "ambiance"
              )
            }
          >
            AMBIANCE
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "gallery"
              )
            }
          >
            GALLERY
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "events"
              )
            }
          >
            PRIVATE EVENTS
          </button>


          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "visit"
              )
            }
          >
            VISIT US
          </button>

        </nav>


        {/* =================================================
            RIGHT ACTIONS
        ================================================= */}

        <div className="theme4-header-actions">


          {/* CART */}

          <button
            type="button"
            className="theme4-header-cart"
            onClick={goCart}
            aria-label="Open cart"
          >

            <span className="theme4-header-cart-label">
              CART
            </span>

            <span className="theme4-header-cart-icon">
              ◇
            </span>

            <span className="theme4-header-cart-count">
              {cartCount}
            </span>

          </button>


          {/* =================================================
              MOBILE MENU
          ================================================= */}

          <button
            type="button"
            className={
              `theme4-mobile-menu-button ${
                menuOpen
                  ? "theme4-mobile-menu-open"
                  : ""
              }`
            }
            onClick={toggleMenu}
            aria-label={
              menuOpen
                ? "Close menu"
                : "Open menu"
            }
            aria-expanded={menuOpen}
          >

            <span></span>
            <span></span>
            <span></span>

          </button>

        </div>

      </div>


      {/* =================================================
          MOBILE DROPDOWN
      ================================================= */}

      <div
        className={
          `theme4-mobile-dropdown ${
            menuOpen
              ? "theme4-mobile-dropdown-open"
              : ""
          }`
        }
      >

        <button
          type="button"
          onClick={goHome}
        >
          <span>01</span>
          HOME
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "story"
            )
          }
        >
          <span>02</span>
          OUR STORY
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "menu"
            )
          }
        >
          <span>03</span>
          MENU
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "ambiance"
            )
          }
        >
          <span>04</span>
          AMBIANCE
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "gallery"
            )
          }
        >
          <span>05</span>
          GALLERY
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "events"
            )
          }
        >
          <span>06</span>
          PRIVATE EVENTS
        </button>


        <button
          type="button"
          onClick={() =>
            navigateToSection(
              "visit"
            )
          }
        >
          <span>07</span>
          VISIT US
        </button>


        <button
          type="button"
          onClick={goCart}
        >
          <span>08</span>
          YOUR ORDER
        </button>

      </div>

    </header>

  );
}


export default Header;